module.exports = __webpack_public_path__ + "media/country_flags/cv-4bd7c88d.png";